import { HttpErrorProps } from '@leaflink/stash/utils/HttpError.vue';
import { computed, reactive, ref } from 'vue';

const settings = ref<Readonly<HttpErrorProps | undefined>>();

/**
 * A composable for managing the error page. When settings are defined, an error page will be rendered for the current route in `DefaultLayout.vue`.
 */
export function useErrorPage() {
  return reactive({
    /**
     * If defined, the route will render an error page with the specified settings.
     */
    settings,

    /**
     * A computed boolean property returning if the error page is currently being displayed or not.
     */
    isVisible: computed(() => Boolean(settings.value)),
  });
}
